import Vue from "vue";

export default {
  mutations: {
    bindEvents({ curComponent }, { type, data }) {
      curComponent.events[type] = data;
    },
  },
};
